import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Container, Row, Col, Modal } from "react-bootstrap";
import { Copy, Share2, UserCheck, Gift } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { toast } from '../common/Toast/toast';

const referralLink = "sevenmentor.com/referral/xyz1234567890/";

const userData = [
  {
    id: 1,
    name: "Mahesh Bhagawat Waghmare",
    role: "Product Strategy",
    image: "https://randomuser.me/api/portraits/men/67.jpg",
    rewards: 400,
  },
];

const benefits = [
  {
    id: 1,
    icon: <UserCheck size={32} className="me-3 text-primary" />, 
    title: "Become a Verified Talent",
    description: "Get verified to access exclusive job opportunities and rewards.",
    points: "+25",
  },
];

const ReferEarn = () => {
  const [showModal, setShowModal] = useState(false);
  const [copied, setCopied] = useState(false)

  const handleShareClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const shareOnLinkedIn = () => {
    const linkedInURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(referralLink)}`;
    window.open(linkedInURL, "_blank");
  };

  const shareOnTwitter = () => {
    const twitterURL = `https://twitter.com/intent/tweet?text=Join%20me%20on%20Braintrust%20and%20earn%20rewards!%20Sign%20up%20using%20my%20referral%20link:%20${encodeURIComponent(referralLink)}`;
    window.open(twitterURL, "_blank");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const { hasPermission } = useAuth();
  useEffect(() => {
    if (!hasPermission('certificate', 'view','lms')) {
      if (!hasShownToast.current) {
        toast.error('You do not have permission to add departments.');
        navigate('/');
        // console.log("hello")
        hasShownToast.current = true;
      }
    }
  }, [hasPermission, navigate]);

  return (
    <Container className="py-1">
      <Card className="p-1 shadow-lg border-0 text-center">
        <Card.Body>
          <h3 className="fw-bold text-primary">Refer & Earn Rewards</h3>
          <p className="text-dark">
            Invite professionals to join and earn rewards! Share your referral link, and get 1% of their earnings in BTRST for every job they land. Start referring and maximize your rewards today! 🚀
          </p>
          <div className="d-flex align-items-center shadow-sm rounded p-2">
            <input
              type="text"
              className="form-control border-0 text-center fw-bold"
              value={referralLink}
              readOnly
            />
            <Button variant="primary" className="ms-2 d-flex align-items-center" onClick={handleCopy}>
            <Copy size={18} className="me-1" /> {copied ? "Copied!" : "Copy"}
            </Button>
          </div>
          <div className="mt-4 d-flex justify-content-center gap-3">
            <Button variant="outline-primary" className="d-flex align-items-center" onClick={shareOnLinkedIn}>
              <Share2 size={18} className="me-2" /> Share on LinkedIn
            </Button>
            <Button variant="outline-info" className="d-flex align-items-center" onClick={shareOnTwitter}>
              <Share2 size={18} className="me-2" /> Share on Twitter
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Row className="mt-1">
        {userData.map((user) => (
          <Col md={6} key={user.id}>
            <Card className="p-3 shadow-sm border-0 d-flex flex-row align-items-center">
              <img
                src={user.image}
                alt="user"
                className="rounded-circle me-3"
                width={50}
                height={50}
              />
              <div>
                <h6 className="mb-0 fw-bold">{user.name}</h6>
                <small className="text-dark">{user.role}</small>
              </div>
              <div className="ms-auto d-flex align-items-center text-warning">
                <span className="fw-bold me-2">{user.rewards}</span>
                <Gift size={22} />
              </div>
            </Card>
          </Col>
        ))}

        {benefits.map((benefit) => (
          <Col md={6} key={benefit.id}>
            <Card className="p-0 shadow-sm border-0">
              <Card.Body className="d-flex align-items-center">
                {benefit.icon}
                <div>
                  <h6 className="mb-0 fw-bold">{benefit.title}</h6>
                  <small className="text-dark">{benefit.description}</small>
                </div>
                <div className="ms-auto fw-bold text-primary">{benefit.points}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Card className="mt-3 p-1 shadow-sm border-0 text-center">
        <Card.Body>
          <h5 className="fw-bold">Share Your Referral Link</h5>
          <p className="text-dark">Let your network know about this opportunity.</p>
          <Button variant="success" className="px-4 py-2 fw-bold" onClick={handleShareClick}>
            Share Now
          </Button>
        </Card.Body>
      </Card>

      {/* Share Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Share Your Referral Link</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="text-muted">Copy your referral link and share it with your network.</p>
          <div className="d-flex align-items-center shadow-sm rounded p-2">
            <input
              type="text"
              className="form-control border-0 text-center fw-bold"
              value={referralLink}
              readOnly
            />
            <Button variant="primary" className="ms-2 d-flex align-items-center" onClick={handleCopy}>
            <Copy size={18} className="me-1" /> {copied ? "Copied!" : "Copy"}

            </Button>
          </div>
          <div className="mt-4 d-flex justify-content-center gap-3">
            <Button variant="outline-primary" className="d-flex align-items-center" onClick={shareOnLinkedIn}>
              <Share2 size={18} className="me-2" /> Share on LinkedIn
            </Button>
            <Button variant="outline-info" className="d-flex align-items-center" onClick={shareOnTwitter}>
              <Share2 size={18} className="me-2" /> Share on Twitter
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ReferEarn;
